import React, { FC } from 'react';
import { useTicket } from '../../context/TicketContext';

export const Currency: FC = () => {
	const {
		ticket: { currency },
	} = useTicket();
	return <span className="currency padding_left_5">{currency}</span>;
};
